import { onCanvas } from "../../shared/mouseFunctions";
import AbstractTool from "../AbstractTool";
import { PLACE } from "../actions/ActionHelper";

export default class PlacementTool extends AbstractTool {
    resetPreviousTool = true;
    scrollEnabled = true;
    newElements = [];

    activate(newElements = null, sticky = false) {
        this.sticky = sticky;
        if (newElements) {
            this.newElements = newElements;
        }
        this.updateMenuIcon(this.newElements);
        this.setActiveLayerFromSpecies(this.newElements);
        this.activeContextPanel.show(false);
    }

    deactivate() {
        this.newElements = [];
        this.provider.menu.resetCurrentToolIcon();
        this.activeContextPanel.hide();
    }

    passArgs(newElements, sticky = false) {
        this.sticky = sticky;
        this.newElements = newElements;
        this.updateMenuIcon(newElements);
    }

    setActiveLayerFromSpecies(newElements) {
        const speciesId = newElements[0]?.speciesIds?.[0];
        const species = speciesId ? this.speciesCollection.get(speciesId) : null;
        if (species?.Layer) {
            let layerName = Array.isArray(species.Layer) ? species.Layer[0] : species.Layer;
            let layer = this.layers.get(layerName);
            this.activeContextPanel.setActiveLayer(layer?.id ?? null);
        }
    }

    updateMenuIcon(newElements) {
        const speciesId = newElements[0]?.speciesIds?.[0];
        const species = speciesId ? this.speciesCollection.get(speciesId) : null;
        if (!species) return;
        const html = `<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg?v=491#plant-line"></use></svg><img src="${species.thumb || '/permapeople-permaculture-plant-database-blank.jpg'}" style="position:absolute;bottom:-6px;right:-3px;width:14px;height:14px;border-radius:50%;border:1px solid #fff;">`;
        this.provider.menu.setCurrentToolIcon(html);
    }

    display(g) {
        if (this.touch || !onCanvas(this.provider) || this.newElements.length === 0) return;
        g.push();
        g.translate(this.view.snappedRelX, this.view.snappedRelY);
        this.newElements.forEach(element => element.display(g));
        g.pop();
    }

    clickMouseOnCanvas() {
        let activeLayer = this.activeContextPanel.activeLayer;
        let addedDate = this.activeContextPanel.addedDate;
        let removedDate = this.activeContextPanel.removedDate;
        this.newElements.forEach(el => {
            el.layer?.removeElement(el);
            el.layer = activeLayer;
            activeLayer?.addElement(el);
            el.addedDate = addedDate;
            el.removedDate = removedDate;
        });
        let newElements = this.actions.execute(
            PLACE,
            this.newElements,
            this.view.snappedAbsX,
            this.view.snappedAbsY
        );
        if (!this.mobile && !this.sticky && !this.p.keyIsDown(this.p.SHIFT)) {
            this.tools.setTool('select');
            this.sideBar.setTab('info');
            this.selection.select(newElements);
        }
        return false;
    }

    moveMouse() {
        this.cursor.cross();
    }

    getTips() {
        let multiple = this.newElements.length > 1;
        let count = multiple ? this.newElements.length + ' elements' : 'the element';
        let pronoun = multiple ? 'them' : 'it';
        if (this.touch) {
            return `Tap on the canvas to place ${count}.`;
        }
        return `Click to place ${count}. Hold SHIFT to place ${pronoun} multiple times.`
    }

    pressKey(code) {
        switch (code) {
            case 27: // Esc
                this.tools.setTool('select');
                return;
            case 37: // left arrow
                this.view.move(this.arrowMove, 0);
                return;
            case 38: // up arrow
                this.view.move(0, this.arrowMove);
                return;
            case 39: // right arrow
                this.view.move(-this.arrowMove, 0);
                return;
            case 40: // down arrow
                this.view.move(0, -this.arrowMove);
                return;
        }
    }
}
